"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _constants = require("./constants");

var _PropertyMarker = _interopRequireDefault(require("../PropertyMarkers/PropertyMarker"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/util/MapMarkerPositioner.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var MapMarkerPositioner =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(MapMarkerPositioner, _Component);

  function MapMarkerPositioner(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.mapDot = _this.mapDot.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = MapMarkerPositioner.prototype;

  _proto.getDots = function getDots() {
    if (!this.props.overlay || (0, _isEmpty2.default)(this.props.markers)) {
      return null;
    }

    return this.props.markers.map(this.mapDot);
  };

  _proto.getIsHighZoom = function getIsHighZoom() {
    return this.props.zoom > _constants.DEFAULT_HIGH_ZOOM_LEVEL;
  };

  _proto.calculateLngLatTranslate = function calculateLngLatTranslate(marker) {
    var northSouthLat = marker.northSouthLat,
        eastWestLng = marker.eastWestLng;
    var overlay = this.props.overlay; // valid example
    // lat = 45.479898
    // lng = -122.5904647

    var lat = northSouthLat;
    var lng = eastWestLng;

    if (Math.abs(lat) > 1000) {
      lat /= 1000000;
      lng /= 1000000;
    }

    var latLng = new google.maps.LatLng(lat, lng);
    var topRight = overlay.getProjection().fromLatLngToDivPixel(latLng);
    var childLeft = topRight.x;
    var childTop = topRight.y;
    return "translateX(-50%) translateX(" + childLeft + "px) translateY(-50%) translateY(" + childTop + "px)";
  };

  _proto.mapDot = function mapDot(marker) {
    if (!marker) {
      return null;
    }

    var northSouthLat = marker.northSouthLat,
        eastWestLng = marker.eastWestLng,
        selected = marker.selected,
        isHovered = marker.isHovered;

    if (northSouthLat && eastWestLng) {
      var dotPositionStyle = this.calculateLngLatTranslate(marker);
      return _react.default.createElement(_PropertyMarker.default, _extends({
        zIndex: selected || isHovered ? 1 : 0,
        transformStyle: dotPositionStyle,
        key: "parceldiv_" + marker.key,
        role: "presentation"
      }, marker, {
        isHighZoom: this.getIsHighZoom(),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      }));
    }

    return null;
  };

  _proto.render = function render() {
    var markers = this.props.markers;
    var countClass = markers.length > 100 ? 'many-results' : 'few-results';
    /* eslint-disable zillow/jsx-a11y/no-static-element-interactions */

    /* eslint-disable zillow/jsx-a11y/click-events-have-key-events */

    return _react.default.createElement("div", {
      className: "BulkPropertyMapMarker " + countClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92
      },
      __self: this
    }, this.getDots());
    /* eslint-enable zillow/jsx-a11y/no-static-element-interactions */

    /* eslint-enable zillow/jsx-a11y/click-events-have-key-events */
  };

  return MapMarkerPositioner;
}(_react.Component);

MapMarkerPositioner.propTypes = process.env.NODE_ENV !== "production" ? {
  zoom: _propTypes.default.number,
  // The google map object for projection mapping lat lng to pixel positions
  overlay: _propTypes.default.shape({}).isRequired,
  markers: _propTypes.default.arrayOf(_propTypes.default.object)
} : {};
MapMarkerPositioner.defaultProps = {
  zoom: 0,
  markers: []
};
var _default = MapMarkerPositioner;
exports.default = _default;